/**
 * @generated SignedSource<<f8b4fc8d700531c41d3d0cbad766bfb3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type IdentityAccountTypes = "CANDIDATE" | "EMPLOYER" | "INTERNAL" | "%future added value";
export type IdentityUserLayoutQuery$variables = {
  identityUserCode: number;
};
export type IdentityUserLayoutQuery$data = {
  readonly identityUser: {
    readonly __id: string;
    readonly accountTypes: ReadonlyArray<IdentityAccountTypes>;
    readonly code: number;
    readonly createdAt: string;
    readonly email: string;
    readonly firstName: string | null | undefined;
    readonly id: string;
    readonly identityUserId: string;
    readonly lastLoggedIn: string | null | undefined;
    readonly lastName: string | null | undefined;
    readonly updatedAt: string;
  } | null | undefined;
};
export type IdentityUserLayoutQuery = {
  response: IdentityUserLayoutQuery$data;
  variables: IdentityUserLayoutQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "identityUserCode"
  }
],
v1 = [
  {
    "alias": "identityUser",
    "args": [
      {
        "kind": "Variable",
        "name": "code",
        "variableName": "identityUserCode"
      }
    ],
    "concreteType": "IdentityUser",
    "kind": "LinkedField",
    "name": "identityUserByCode",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "identityUserId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastLoggedIn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "firstName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accountTypes",
        "storageKey": null
      },
      {
        "kind": "ClientExtension",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__id",
            "storageKey": null
          }
        ]
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IdentityUserLayoutQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IdentityUserLayoutQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "72600eb64ccca5488572aafaca34de41",
    "id": null,
    "metadata": {},
    "name": "IdentityUserLayoutQuery",
    "operationKind": "query",
    "text": "query IdentityUserLayoutQuery(\n  $identityUserCode: Long!\n) {\n  identityUser: identityUserByCode(code: $identityUserCode) {\n    id\n    code\n    identityUserId\n    lastLoggedIn\n    updatedAt\n    createdAt\n    firstName\n    lastName\n    email\n    accountTypes\n  }\n}\n"
  }
};
})();

(node as any).hash = "132b26a418b18eac69081c86cdb6e4c5";

export default node;
